import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HelpComponent } from './help/help.component';
import { ReportsAndDashboardsComponent } from './reports-and-dashboards/reports-and-dashboards.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { SubscriptionDetailComponent } from './subscriptions/subscription-detail/subscription-detail.component';
import { EmbeddedDashboardComponent } from './reports-and-dashboards/embedded-dashboard/embedded-dashboard';
import { TokenResolverService } from './services/token-resolver.service';
import { SettingsComponent } from './settings/settings.component';
import { ScheduleSubscriptionComponent } from './schedule-subscription/schedule-subscription.component';
import { ErrorComponent } from './error/error.component';
import { ChatComponent } from './chat/chat.component';
import { aiFeatureGuard } from './services/ai-feature.guard';
import { LogoffComponent } from './logoff/logoff.component';
import { SsoErrorComponent } from './sso-error/sso-error.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { subscriptionsAccessGuard } from './guards/subscriptions-access.guard';
import { helpAccessGuard } from './guards/help-access.guard';

export const routes: Routes = [
  {
    path: 'admin', loadChildren: () => import('./admin/admin.routes')
  },
  {
    path: 'internal', loadChildren: () => import('./internal/internal.routes')
  },
  {
    path: 'home', loadChildren: () => import('./home/home.routes')
  },
  {
    path: 'embedded-dashboard/:dashboardId',
    component: EmbeddedDashboardComponent, resolve: {
      access: TokenResolverService
    }
  },
  {
    path: 'reports-and-dashboards', component: ReportsAndDashboardsComponent, resolve: {
      access: TokenResolverService
    }
  },
  // Subscriptions routes: removed leavesAccessGuard so all clients can access if feature flag enabled
  {
    path: 'subscriptions', component: SubscriptionsComponent, resolve: {
      access: TokenResolverService
    },
    canActivate: [subscriptionsAccessGuard]
  },
  {
    path: 'subscriptions/:id', component: SubscriptionDetailComponent, resolve: {
      access: TokenResolverService
    },
    canActivate: [subscriptionsAccessGuard]
  },
  {
    path: 'edit-subscription', component: ScheduleSubscriptionComponent, resolve: {
      access: TokenResolverService
    },
    canActivate: [subscriptionsAccessGuard]
  },
  {
    path: 'help', component: HelpComponent, resolve: {
      access: TokenResolverService
    },
    canActivate: [helpAccessGuard]
  },
  { path: 'error', component: ErrorComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'logoff', component: LogoffComponent },
  { path: 'sso-error', component: SsoErrorComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'chat', component: ChatComponent, canActivate: [() => aiFeatureGuard()] },
  {
    path: '', redirectTo: '/home', pathMatch: 'prefix', resolve: {
      access: TokenResolverService
    }
  },
  { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];
